<template>
  <div class="route-index">
    <header-component @showTeachersDay="showTeachersDay" @showTrainingCamp="showTrainingCamp" @showNewSemester="showNewSemester" />
    <div class="main">
      <browser-detect v-if="show" v-model="show" />
      <guide-video v-if="playGuide" />
      <nav-component v-show="!isHideNav" />
      <!-- <bind-phone /> -->
      <div
        v-if="loading"
        v-show="!flag"
        ref="routerView"
        class="route-view scrollbar"
        :class="{'course-detail': routerView === 'courseDetail',  'mlz-detail': $route.meta.mlz || $route.meta.clearPadding}"
      >
        <router-view></router-view>
        <div
          v-if="!$store.state.customInfo && $route.name === 'dashboard'"
          class="bottom-bar"
        >© 2019 Shenzhen Dianmao Technology Company Limited深圳点猫科技有限公司 / 粤ICP备15030912</div>
      </div>

      <div class="box" v-else>
        <img src="https://public-static-edu.codemao.cn/redboat/static/jumper1.png" alt />
        <p class="p1">加载中...</p>
      </div>
    </div>
    <footer-ad v-show="$route.name === 'dashboard' && !isNC"></footer-ad>
    <help-and-feedback v-show="$route.name !== 'courseDetail' && showHelp" />
    <teachers-day ref="teachersDay" />
    <check-skip-modal />
    <teaching-notice />
    <teacher-training-camp ref="teacherTrainingCamp" />
    <course-offline />
    <new-semester ref="newSemester" />
    <outDateRemind />
  </div>
</template>

<script>
// import BindPhone from '@/components/BindPhone'
import HeaderComponent from '@/components/header'
import NavComponent from '@/components/nav'
import FooterAd from '@/components/footerAd'
import HelpAndFeedback from '@/components/HelpAndFeedback'
import { mapMenus } from '@/utils/utils'
import TeachersDay from '@/components/teachersDay'
import CheckSkipModal from '@/components/checkSkipModal'
import TeacherTrainingCamp from '@/components/teacherTrainingCamp'
import CourseOffline from '@/components/courseOffline'
import NewSemester from '@/components/newSemester'
import outDateRemind from '@/components/outDateRemind'

export default {
  components: {
    HeaderComponent,
    NavComponent,
    CheckSkipModal,
    'BrowserDetect': () => import('@/components/browserDetect' /* webpackChunkName: "BrowserDetect" */),
    'GuideVideo': () => import('@/components/guideVideo' /* webpackChunkName: "GuideVideo" */),
    FooterAd,
    // BindPhone,
    HelpAndFeedback,
    TeachersDay,
    TeachingNotice: () => import('@/components/teachingNotice' /* webpackChunkName: "teachingNotice" */),
    TeacherTrainingCamp,
    CourseOffline,
    NewSemester,
    outDateRemind
  },
  data () {
    return {
      show: false,
      scrollTop: 0,
      compareScrollTop: 0,
      timer: null,
      flag: false,
      loading: false
    }
  },
  async created () {
    this.$store.dispatch('getClassUserInfo').then((res) => {
      window.Sensors.setProfile({
        edu_real_name: res.real_name,
        edu_role_id: res.role_id + '',
        edu_unit_id: res.unit_id + '',
        edu_unit_type_id: res.unit_type_id + '',
        edu_unit_province_id: res.province_id + '',
        edu_unit_city_id: res.city_id + '',
        edu_unit_district_id: res.district_id + ''
      })
      this.$store.dispatch('getRecentRecord')
      this.$store.dispatch('getSchoolInfo')
    })
    this.$store.dispatch('getGradeList')
    await this.$store.dispatch('getCodemaoUserInfo')
    this.$store.dispatch('getCodemaoAuthUserInfo')
    this.$store.dispatch('getMenu')
    // 获取B端信息后上报一次数据埋点
    this.$store.dispatch('reportClassroomLogin')
    this.$store.dispatch('reportStart')
    // 设置上报用户画像
    this.$store.dispatch('reportUserDetail')
    // 获取用户手机号
    // this.$store.dispatch('getUserRealPhone')
    // 学生权限不请求
    if (!this.isStudent) {
      // 获取是否跳过
      this.$store.dispatch('getHasCompleteMsg')
      // 最新学校库消息
      this.$store.dispatch('getMessageLast')
    }
  },
  watch: {
    tempMenus: {
      handler: function (val) {
        // 定制教室没有菜单时显示加载中...
        if (!val.length && this.customInfo) this.loading = false
        if (!val.length) return
        const path = mapMenus(this.menuRouter, val[0])
        // 有菜单时跳转到第一个菜单页面
        this.$route.path === '/dashboard' && path !== 'dashboard' ? this.flag = true && this.$router.replace(path) : this.flag = false
        // 第一个菜单为平台首页，则显示平台首页, 不是，则显示路由对应页面
        path === 'dashboard' && this.customInfo ? this.loading = true : this.loading = true
      },
      immediate: true
    },
    '$route': {
      handler (val) {
        if (!val) return
        this.$store.dispatch('reportClassroomPageVisit')
      },
      immediate: true
    }
  },
  computed: {
    isHideNav () {
      const routeName = this.$route.name
      switch (routeName) {
        case 'markWork':
        case 'viewGrowthFile': // 课程中心成长档案
        case 'learningviewGrowthFile': // 学情报告成长档案
          return true
        default:
          return false
      }
    },
    playGuide: {
      get () {
        return this.$store.state.base.playGuide
      },
      set (playGuide) {
        this.$store.commit('setState', {
          module: 'base',
          key: 'playGuide',
          value: playGuide
        })
      }
    },
    is_default_password: {
      get () {
        return this.$store.state.user.is_default_password
      },
      set (is_default_password) {
        this.$store.commit('setState', {
          module: 'user',
          key: 'is_default_password',
          value: is_default_password
        })
      }
    },
    tempMenus () {
      return this.$store.state.dashboard.tempMenus
    },
    menuRouter () {
      return this.$store.state.dashboard.menuRouter
    },
    customInfo () {
      return this.$store.state.customInfo
    },
    user () {
      return this.$store.state.user
    },
    isStudent() {
      return this.user.role_id === 20001
    },
    isNC() { // 南昌定制教室
      const customInfo = this.$store.state.customInfo
      if (customInfo) {
        const nc = customInfo.url.split('/')[3]
        return nc === 'nc'
      } else {
        return false
      }
    },
    showHelp() {
      const menu = this.$store.state.dashboard.menu
      const hasHelp = menu.find(item => item.path === 'help')
      return !!hasHelp
    }
  },
  methods: {
    showTeachersDay() {
      this.$refs.teachersDay.show(true)
    },
    showTrainingCamp() {
      this.$refs.teacherTrainingCamp.show(true)
    },
    showNewSemester() {
      this.$refs.newSemester.show(true)
    }
  },
  mounted () {
    const u = navigator.userAgent
    this.show =
      u.indexOf('Trident') > -1 ||
      u.indexOf('Edge') > -1 ||
      u.indexOf('QQ') > -1
  }
}
</script>

<style scoped lang="scss">
.bottom-bar {
  width: 100%;
  text-align: center;
  font-size: 12px;
  color: #aaa;
}
.route-view {
  padding: 20px 20px;
  flex: 1;
  max-width: calc(100% - 200px);
  // overflow-y: auto;
  width: 100%;
  background: rgba(var(--primary-color-source), 0.02);
}
.route-index {
  height: 100%;
  width: 100%;
  min-height: 900px;
}
.main {
  display: flex;
  // height: calc(100% - 60px);
  width: 100%;
}
.course-detail {
  padding: 0;
  max-width: 100%;
  background: #333;
}
.mlz-detail {
  padding: 0;
  max-width: 100%;
  background: #f5f8fa;
}
.box {
  margin: auto;
}

.p1 {
  font-size: 20px;
  color: #333;
  margin-top: 30px;
  text-align: center;
}
</style>
